module.exports = __webpack_public_path__ + "static/media/ic_mic_off.7c87ebc2.svg";